export const signInUserData = [
    {
        id: '1',
        avatar: '/img/avatars/thumb-11.jpg',
        email: "kev0620@gmail.com",
        first_name: "JK",
        last_name: "Enriquez",
        middle_name: "Palacio",
        suffix_name: "", 
        gender: "Male", 
        age: 0, 
        birth_date: "2023-2-1", 
        address: "saadsadadaddsada", 
        marital_status: "sadasdsad", 
        password: "warlord",
        authority: ['ADMIN', 'USER']
    },
    {
        id: '2',
        avatar: '/img/avatars/thumb-1.jpg',
        email: "admin@test.com",
        first_name: "Admin",
        last_name: "User",
        middle_name: "",
        suffix_name: "", 
        gender: "Female", 
        age: 30, 
        birth_date: "1990-1-1", 
        address: "Photography Studio", 
        marital_status: "Single", 
        password: "admin",
        authority: ['ADMIN', 'USER']
    },
    {
        id: '3',
        avatar: '/img/avatars/thumb-2.jpg',
        email: "client@test.com",
        first_name: "Client",
        last_name: "User",
        middle_name: "",
        suffix_name: "", 
        gender: "Male", 
        age: 35, 
        birth_date: "1985-1-1", 
        address: "Client Location", 
        marital_status: "Single", 
        password: "client",
        authority: ['USER']
    }
]